import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const LongTermCareDailyBenefitAmount = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="LongTermCareDailyBenefitAmount"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Daily Benefit Amount"
          decimalScale={2}
          allowNegative={false}
          leftIcon="far fa-dollar-sign"
          maxLength={14}
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
        />
      )}
    />
  );
};
